import React from 'react';

const ErrorPage: React.FC = () => {
    return (
        <div>
            <h1>Oops!</h1>
            <p>
                Page does not exist or you don't have permission to access it.
            </p>
        </div>
    );
};

export default ErrorPage;